import { render, staticRenderFns } from "./ManageItems.vue?vue&type=template&id=4f659f42&"
import script from "./ManageItems.vue?vue&type=script&lang=ts&"
export * from "./ManageItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports